import { render, staticRenderFns } from "./EditarTablaSeriados.vue?vue&type=template&id=1f5817e4&"
import script from "./EditarTablaSeriados.vue?vue&type=script&lang=ts&"
export * from "./EditarTablaSeriados.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports